import * as playerActions from './actions';
import reducer from './reducers';
import * as playerSelectors from './selectors';
import * as playerTypes from './types';

export { playerActions, playerSelectors, playerTypes };

export default reducer;
